export const HABERDASHERY_SHOP_KEY = "haberdashery";
export const READY_MADE_SHOP_KEY = "ready-made";
export const TEXTILE_SHOP_KEY = "textiles";
export const JEWELRY_HIRE_CATALOG_KEY = "jewelry-hire";

export const SHOP_KEYS = Object.freeze([
  HABERDASHERY_SHOP_KEY,
  READY_MADE_SHOP_KEY,
  TEXTILE_SHOP_KEY,
]);

export const CATALOG_KEYS = Object.freeze([
  ...SHOP_KEYS,
  JEWELRY_HIRE_CATALOG_KEY,
]);

export const SHOP_PATHS = Object.freeze({
  [HABERDASHERY_SHOP_KEY]: `/shop/${HABERDASHERY_SHOP_KEY}`,
  [READY_MADE_SHOP_KEY]: `/shop/${READY_MADE_SHOP_KEY}`,
  [TEXTILE_SHOP_KEY]: `/shop/${TEXTILE_SHOP_KEY}`,
});

export const SHOPS = [
  {
    shopKey: HABERDASHERY_SHOP_KEY,
    name: "Haberdashery",
    description:
      "Vintage buttons, buckles, braids, trims, tools and specialist notions for costume, tailoring and design projects.",
  },
  {
    shopKey: READY_MADE_SHOP_KEY,
    name: "Ready-Made",
    description:
      "Vintage reproduction garments and archive-inspired ready-made clothing from the 1900s to the 1980s.",
  },
  {
    shopKey: TEXTILE_SHOP_KEY,
    name: "Textiles",
    description:
      "Vintage and contemporary fabrics, including suiting, shirting and specialist costume textiles by the metre, half metre or sample.",
  },
];

export const CATALOGS = [
  ...SHOPS,
  {
    shopKey: JEWELRY_HIRE_CATALOG_KEY,
    name: "Jewellery Hire",
    description: "Jewellery available for private hire.",
  },
];

export const isValidShopKey = (shopKey = "") =>
  SHOP_KEYS.includes(String(shopKey || "").trim());

export const isValidCatalogKey = (shopKey = "") =>
  CATALOG_KEYS.includes(String(shopKey || "").trim());
